import type { DeepPartial } from '@luna/utils-ts';

import type { StatementsConfig } from '../ProductsConfig';
import { config as deliveryChange } from './delivery-change-config/HU';

export const statements: DeepPartial<StatementsConfig> = {
    deliveryEditorVersion: 2,
    forceNoEmail: true,
    deliverySelectable: true,
    modes: {
        electronic: 'ONLY_ELECTRONIC',
        postal: 'PAPER',
    },
    tableColumns: {
        DEFAULT: ['NAME', 'TIMESPAN', 'FORMAT', 'DOWNLOAD'],
        CREDIT: ['NAME', 'TIMESPAN', 'FORMAT', 'DOWNLOAD'],
    },
    deliveryChange,
    addAccessTokenToDownloadBody: true,
};
